import { Fragment } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import InfoTooltipButton from "~/components/InfoTooltipButton/InfoTooltipButton";

const AssetInsightsSectionHeading = ({
  title,
  tooltip,
}: {
  title: string;
  tooltip?: string | React.ReactNode;
}) => (
  <Fragment>
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      {tooltip && <InfoTooltipButton title={tooltip} placement="right" />}
    </Stack>
  </Fragment>
);

export default AssetInsightsSectionHeading;
